import { useEffect, useState } from 'react';
import { spore } from '@/spore/runtime';

export function useSporeSnapshot(hz = 15) {
  const [snap, setSnap] = useState(() => spore.getSnapshot());
  useEffect(() => {
    const id = setInterval(() => setSnap(spore.getSnapshot()), 1000 / hz);
    return () => clearInterval(id);
  }, [hz]);
  return snap;
}
